<table aria-label="Apex measures" class="wrapper-print-table">
	<thead>
		<tr>
			<th>{{ labels().PRINT_APEX_TABLE_HEADER }}</th>
			@if (hasAP) { <th>{{ labels().APEX_TABLE_AP_HEADER }}</th> }
			@if (hasLT) { <th>{{ labels().APEX_TABLE_LT_HEADER }}</th> }
			<th>{{ labels().PRINT_APEX_TABLE_AXIAL_HEADER }}</th>
		</tr>
	</thead>
	<tbody>
		@if (isFemur || isLongLeg) {
		<tr>
			<td>{{ labels().APEX_TABLE_FEMUR }}</td>
			@if (hasAP) { <td>{{ apFemurMeasure }}</td> }
			@if (hasLT) { <td></td> }
			<td>{{ axRotFemurMeasure }}</td>
		</tr>
		}
		@if (isTibia || isLongLeg) {
		<tr>
			<td>{{ labels().APEX_TABLE_TIBIA }}</td>
			@if (hasAP) { <td>{{ apTibiaMeasure }}</td> }
			@if (hasLT) { <td>{{ ltTibiaMeasure }}</td> }
			<td>{{ axRotTibiaMeasure }}</td>
		</tr>
		}
	</tbody>
</table>